/* eslint-disable react/prop-types */
import React from 'react';

// Weather Center card container. Styling comes from the scoped `.card` rule in
// styles.js (this component renders inside the WeatherCenter styled root).
const Card = ({ className = '', children, ...rest }) => (
  <div className={`card ${className}`.trim()} {...rest}>
    {children}
  </div>
);

export default Card;
